<script>
    import {topicMetadata, metadataCollections} from '../area-reports/layers';
    import {beforeUpdate} from 'svelte';

    import MetadataItem from './MetadataItem.svelte';

    export let topicId;

    $: metadataLink = topicMetadata.find(m => m.id === topicId);

    $: descriptionId = metadataLink && metadataLink.description
    $: provenanceId = metadataLink && metadataLink.provenance

    $: description = descriptionId ? metadataCollections.find(mc => mc.id === descriptionId) : undefined;
    $: provenance = provenanceId ? metadataCollections.find(mc => mc.id === provenanceId) : undefined;

    beforeUpdate(() => {
      console.log(`TopicMetadata ${topicId}`);
    })
</script>

{#if description}
    {#each description.metadata as metadata}
        <MetadataItem kind="Description" title={metadata.title} description={metadata.description}/>
    {/each}
{/if}

{#if provenance}
    {#each provenance.metadata as metadata}
        <MetadataItem kind="Data source" title={metadata.title} description={metadata.description}/>
    {/each}
{/if}
